import { ReactElement } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { path } from '@/routes/Routes.helpers';
import { privateRoutes } from '@/routes/Routes.private.config';
import { publicRoutes } from '@/routes/Routes.public.config';
import { serviceRoutes } from '@/routes/Routes.service.config';

const RouterComponent = (): ReactElement => {
    const allRoutes = { ...privateRoutes, ...publicRoutes, ...serviceRoutes };

    const renderRoutes = (routes: typeof allRoutes): ReactElement[] => {
        const elements: ReactElement[] = [];

        Object.values(routes).forEach(({ element, path, subRoutes }) => {
            if (element) {
                elements.push(
                    <Route key={path} path={path} element={element} />,
                );
            }

            if (subRoutes) {
                elements.push(...renderRoutes(subRoutes));
            }
        });

        return elements;
    };

    return (
        <Routes>
            {renderRoutes(allRoutes)}
            <Route
                path="*"
                element={<Navigate to={path('notFound')} replace />}
            />
        </Routes>
    );
};

export default RouterComponent;
